import React from 'react'
import { Grid } from '@material-ui/core'
import { components, constants, useServices } from 'cng-web-lib'
import { useParams } from 'react-router-dom'
import NaCountryCodeApiUrls from 'src/apiUrls/NaCountryCodeApiUrls'
import FormProperties from './FormProperties'

const {
  form: { CngEditForm },
} = components

const {
  filter: { EQUAL },
} = constants

function EditPage({ showNotification }) {
  const { id } = useParams()
  const { fetchRecords } = useServices()

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CngEditForm
          fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
          showNotification={showNotification}
          renderBodySection={(labelMap, shouldHideMap) => (
            <FormProperties.Fields
              disabled={false}
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
            />
          )}
          formikProps={FormProperties.formikProps}
          toClientDataFormat={FormProperties.toClientDataFormat}
          toServerDataFormat={FormProperties.toServerDataFormat}
          fetch={{
            onSendRequest: (onSuccess, onError, onComplete) => {
              fetchRecords.execute(
                NaCountryCodeApiUrls.GET,
                {
                  filters: [{ field: 'id', operator: EQUAL, value: id }],
                  customData: { codeMType: 'NACountryCode' },
                },
                onSuccess,
                onError,
                onComplete
              )
            },
          }}
          update={{ url: NaCountryCodeApiUrls.PUT }}
          id={id}
        />
      </Grid>
    </Grid>
  )
}

export default EditPage
